import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { useSelector, useDispatch } from "react-redux";
import ThemMoiTraGop from "containers/DanhSachHopDongChoDuyet/Sua/suaTraGop";
import ChiTietHopDong from "../../../../../../service/chiTietHopDongApi";
// import ThemMoiTraGop from "containers/TraGop/SubContainer/themMoiTraGop";
import { convertDate } from "utils/formatDate";

import { pushNotification } from "utils/notifications";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../../../actions/DanhSachHopDongChoDuyet";
export const BtnSuaTraGop = ({
  item,
  showFormTraGop,
  isDuDungPhiPhatDongLaiTatToan,
  SuDungPhiPhat_DongLai_Cham,
  isSuDungCongTacVienNhanVien,
  isSuDungTatToanSom,
}) => {
  const [isModalVisible, setModalVisible] = useState(false);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);

  const themmoitragop = useSelector((state) => state.themmoitragop);

  const choVayEdit = {};
  const [chovayChiTiet, setChoVay] = useState(choVayEdit);

  const loadTraGop = () => {
    getListHopDongChoDuyet(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const setModalTraGopShow = (chovay) => {
    let choVayEdit = null;
    if (chovay) {
      choVayEdit = { ...chovay };
      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayThanhToan = convertDate(chovay.DatePaid);
      //Danh sách chờ duyệt không trả cột ChiPhiVay1 như danh sách trả góp; lấy trước khi reducer làm tròn ChiPhiVay còn 2 số
      if (choVayEdit.ChiPhiVay1 == null && choVayEdit.ChiPhiVay != null)
        choVayEdit.ChiPhiVay1 = parseFloat(
          Number(choVayEdit.ChiPhiVay).toFixed(6)
        );
    }
    ChiTietHopDong.getChiTietHopDong1(item.ChoVayId).then((response) => {
      setChoVay(response.data);
    });
    themmoitragop.postTraGopReturn = false;
    themmoitragop.TaiSanTraGop.AnhTaiSan = "";
    if (isModalVisible) {
      // let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      loadTraGop(dataSearch);
      // this.setState({ dataSearch });
      // this.loadTraGop(dataSearch);
    }
    // showFormTraGop(choVayEdit);
    showFormTraGop(choVayEdit);
    dispatch(getListHopDongChoDuyet(dataSearch));
    setModalVisible(!isModalVisible);
  };

  // useEffect(() => {
  //   setModalTraGopShow();
  // }, [item.ChoVayId]);

  return (
    <>
      <a onClick={(e) => setModalTraGopShow(item)} href={() => false}>
        <PopoversBootrap
          contentText="Sửa"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
           <img src="/app-assets/images/icon-edit-v2.png" />
        </PopoversBootrap>
      </a>

      {isModalVisible && (
        <ThemMoiTraGop
          show={isModalVisible}
          data={chovayChiTiet}
          onHide={(e) => setModalTraGopShow(null)}
          isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
          SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
          isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
          isSuDungTatToanSom={isSuDungTatToanSom}
        ></ThemMoiTraGop>
      )}
    </>
  );
};
